<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    ref="galleryBlockRef"
    class="gallery-block"
  >
    <ts-row>
      <ts-col
        v-for="(image, idx) in galleryImages"
        :key="idx"
        :ts-w="colCount"
        ts-align="center"
      >
        <div class="image-wrapper">
          <img
            :src="image.url"
            :alt="isDecorativeImage(image) ? '' : image.alt_text"
            :style="{ height: imgHeight }"
            :class="{ 'lightbox-cursor': gallery.hasLightbox }"
            tabindex="0"
            @click="handleImageClick($event, idx)"
            @keydown.enter="handleImageClick($event, idx)"
            @keydown.space="handleImageClick($event, idx)"
          />
        </div>
        <div class="caption-container">
          <div
            v-if="image.caption && gallery.showCaptions"
            class="caption"
            :style="{ textAlign: gallery.captionsAlignment }"
            v-html="image.caption"
          />
        </div>
      </ts-col>
    </ts-row>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useElementSize } from '@vueuse/core';
import { useStore } from 'vuex';
import tsRow from '../../global/tsRow.vue';
import tsCol from '../../global/tsCol.vue';

const props = defineProps({
  config: {
    type: Object,
    default: () => ({
      gallery: {
        images: [],
        columns: 1,
        hasLightbox: false,
        showCaptions: false,
        captionsAlignment: 'left',
      },
    }),
  },
});

defineOptions({
  name: 'GalleryBlock',
});

const store = useStore();
const galleryBlockRef = ref(null);

const gallery = computed(() => props.config?.gallery ?? {});
const galleryImages = computed(() => gallery.value.images ?? []);
const colCount = computed(() => 12 / (gallery.value.columns || 1));

const { width: blockWidth } = useElementSize(galleryBlockRef);
const imgHeight = computed(() => {
  const width = blockWidth.value ?? 0;
  const columns = gallery.value.columns || 1;
  const columnWidth = width / columns;
  return `${columnWidth}px`;
});

function handleImageClick(event, index) {
  if (!gallery.value.hasLightbox) return;
  openLightbox(event, galleryImages.value, index);
}

function openLightbox(e, images, startingIndex) {
  store.commit('setPrevFocusedElem', e.target);
  store.commit('setLightBoxCurrentIndex', startingIndex);
  store.commit('openLightbox');
  store.commit('setLightboxImages', images);
}

function isDecorativeImage(image) {
  return !!image.decorative_image;
}
</script>

<style scoped lang="scss">
.gallery-block {
  &.full-width {
    max-width: 100%;
  }
}
.image-wrapper {
  margin: 5px;
  overflow: hidden;
  z-index: 4;
}
img {
  width: 100%;
  object-fit: cover;
}
.lightbox-cursor {
  cursor: pointer;
}
</style>
